import { attachmentService } from "client-app-core";

export const attachFilesToAlert = (alertId, entityType, files) => {
    return () => {
        attachmentService.uploadFiles(alertId, "alert", files, (err, result) => {
            if (err) {
                console.log(err);
            }
            console.log(result);
        });
    };
};